import React from "react";

function FriendIcons() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="Add_friend" data-name="Add friend" transform="translate(0 0.294)">
        <circle
          id="Ellipse_2337"
          data-name="Ellipse 2337"
          cx="24"
          cy="24"
          r="24"
          transform="translate(0 -0.294)"
          opacity="0.7"
        />
        <path
          id="add_friend-2"
          data-name="add friend"
          d="M15.655,16.446v2.435a7,7,0,0,0-9.324,6.6H4a9.333,9.333,0,0,1,11.655-9.031Zm-2.331-1.459a6.993,6.993,0,1,1,6.993-6.993A6.991,6.991,0,0,1,13.324,14.987Zm0-2.331A4.662,4.662,0,1,0,8.662,7.993,4.661,4.661,0,0,0,13.324,12.655Zm6.993,6.993v-3.5h2.331v3.5h3.5V21.98h-3.5v3.5H20.318v-3.5h-3.5V19.649Z"
          transform="translate(9.059 10.827)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default FriendIcons;
